import decApi from "@/api/decApi"

export async function confirmDeleteDec(decId, decNom, deleteCallback = null) {
    let {isConfirmed} = await this.$swal({
        title: 'Supprimer Dec',
        text: `Etes-vous sûr de vouloir supprimer le dec ${decNom}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Confirmer',
        cancelButtonText: "Annuler",
        customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
    })

    if(isConfirmed)
        await this.deleteDec(decId, deleteCallback);
}

export async function deleteDec(decId, deleteCallback = null) {
    if(this.hasOwnProperty("deleting"))
        this.deleting = true;
    try {
        await decApi.deleteDec(decId);
        this.showToast("success", "Dec supprimé", "CheckIcon")
        if(deleteCallback != null && typeof deleteCallback === "function")
            deleteCallback(decId);
        
    } catch(e) {
        console.log("e", e)
        this.showToast("danger", "Une erreur s'est produite", "AlertCircleIcon")
    }
    finally {
        if(this.hasOwnProperty("deleting"))
            this.deleting = false;
    }
}